export const listTableStyles = {
    header: 'bg-surface-muted/70',
    head: 'h-12 px-6 text-left text-xs font-semibold text-muted-foreground',
    row: 'hover:bg-surface-subtle',
    cell: 'px-6 py-4 align-middle',
    subtleCell: 'px-6 py-4 text-sm text-muted-foreground align-middle',
    emptyCell: 'px-6 py-12 text-center text-muted-foreground align-middle',
};
